import axiosClient from "../config";

export function getCompanyMembersAccepted(companyId: number, perPage: number = 12, options?: { includeDetails?: boolean; page?: number }) {
    const params: Record<string, unknown> = {
        status: 'confirmed',
        per_page: perPage,
        include_details: options?.includeDetails
    };
    if (options?.page != null) params.page = options.page;
    return axiosClient.get(`/api/v1/companies/${companyId}/members`, { params });
}

export function getCompanyMembersPending(companyId: number) {
    return axiosClient.get(`/api/v1/companies/${companyId}/members?status=pending`);
}

export function addCompanyMember(
  companyId: number, 
  memberData: {
    email?: string;
    first_name: string;
    last_name: string;
    birthday?: string;  // Required if no email
    role?: string;      // Company role (member, admin, superadmin) - defaults to 'member'
    user_role?: string; // System role (voluntary, employee, etc.)
    create_minor?: boolean;  // BLEU Premium: allow member under 15
    legal_representative_consent?: boolean; // Required when create_minor is true
    guardian_email?: string; // Required for minors (<15) — legal representative contact
  }
) {
    return axiosClient.post(`/api/v1/companies/${companyId}/members`, memberData);
}

export function removeCompanyMember(companyId: number, memberId: number) {
    return axiosClient.delete(`/api/v1/companies/${companyId}/members/${memberId}`);
}

export function updateCompanyMemberRole(companyId: number, memberId: number, newRole: string) {
    return axiosClient.put(`/api/v1/companies/${companyId}/members/${memberId}`, { role: newRole });
}

export function acceptMember(companyId: number, memberId: number, role?: string) {
    const payload: { status: string; role?: string } = { status: "confirmed" };
    if (role) {
        payload.role = role;
    }
    return axiosClient.put(`/api/v1/companies/${companyId}/members/${memberId}`, payload);
}

export function importCompanyMembersCsv(
  companyId: number,
  csvFile: File,
  options?: { legalRepresentativeConsent?: boolean }
) {
    const formData = new FormData();
    formData.append('csv_file', csvFile);
    if (options?.legalRepresentativeConsent) {
        formData.append('legal_representative_consent', 'true');
    }
    return axiosClient.post(`/api/v1/companies/${companyId}/members/import_csv`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function resendCompanyGuardianAuthorization(companyId: number, memberId: number | string) {
  return axiosClient.post(
    `/api/v1/companies/${companyId}/members/${memberId}/resend_guardian_authorization`
  );
}